import { render, staticRenderFns } from "./data_card.vue?vue&type=template&id=48a20b8a&scoped=true"
import script from "./data_card.vue?vue&type=script&lang=js"
export * from "./data_card.vue?vue&type=script&lang=js"
import style0 from "./data_card.vue?vue&type=style&index=0&id=48a20b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a20b8a",
  null
  
)

export default component.exports